import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        position: 'relative',
        flex: 1,
    },
    line: {
        zIndex: 1,
    },
    btn: {
        marginTop: '15px',
        fontWeighT: '600',
        textTransform: 'initial'
    },
    inner: {
        paddingLeft: '40px',
        paddingRight: '5px',
        marginTop: '15px'
    },
    wrapper:{
      padding:'0 0 10px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap:'10px'
    }
}